import React, { useMemo } from 'react';
import { Tag } from 'antd';
import type { QuotationRevisionCompareResult } from '@/components/crm/QuotationRevisionComparePanel';

type Props = {
  lineNumber: number;
  itemCode?: string | null;
  comparison?: QuotationRevisionCompareResult;
};

export const QuotationItemsChangedBadge: React.FC<Props> = ({
  lineNumber,
  itemCode,
  comparison,
}) => {
  const change = useMemo(() => {
    if (!comparison?.line_deltas?.length) return null;
    const key = itemCode ? String(itemCode) : String(lineNumber);
    return comparison.line_deltas.find(
      (d) => d.key === key || d.key === String(lineNumber) || d.key.includes(String(lineNumber))
    );
  }, [comparison, lineNumber, itemCode]);

  if (!change) return null;

  return (
    <Tag color="orange" style={{ marginLeft: 4 }}>
      {change.change}
    </Tag>
  );
};

export default QuotationItemsChangedBadge;
